<template>
    <div class="flex justify-center items-center h-screen">
        <div class="text-navy block text-center">
            <img width="250" class="logo-teal" src="/img/logo-teal.png" alt="Logo"/>
            <h1 class="mt-0 mb-2">{{ title?title : '500: Internal Server Error' }}</h1>
            <div class="mb-5">{{ description?description: 'Something went wrong on our servers.'}}</div>
            <div>
                <a class="no-underline" href="https://www.peoplenpartners.com">
                    <el-button class="w-32 bg-navy text-white border-0 py-3 text-sm-scale font-semibold" size="small">
                        Back Home
                    </el-button>
                </a>
            </div>
        </div>
    </div>

</template>

<script>
import {  Link } from '@inertiajs/inertia-vue'

export default {

    props: {
        status: Number,
    },
    components: {
        Link
    },
    computed: {
        title() {
            return {
                503: '503: Service Unavailable',
                500: '500: Internal Server Error',
                404: '404: Page Not Found',
                403: '403: Forbidden',
                419: '419: Authentication Timeout',
                408: '408: Request Timeout',
            }[this.status]
        },
        description() {
            return {
                503: 'Maintenance in progress. Please check back soon.',
                500: 'Something went wrong on our servers.',
                404: 'Page not found. Please try again.',
                403: 'Access denied. You are not authorized to view this page.',
                419: 'Page has expired. Please refresh the page.',
                408: 'Connection lost. Please check your internet connection.',
            }[this.status]
        },
    },
}
</script>
